import { IAppState } from '../../../../common/context/context'
import { CatalogoFilters } from '../../type/filter'

export const selectCatalogoFilterValues = (
  state: IAppState,
  key: string
): CatalogoFilters | null => {
  return state.catalogoFilter[key]?.filters ?? null
}
export const selectCatalogoFilterValuesLoading = (
  state: IAppState,
  key: string
): boolean => {
  return state.catalogoFilter[key]?.loading ?? false
}
